export * from './lib/dialogs/create-subkunde-dialog/create-subkunde-dialog.component';
export * from './lib/dialogs/edit-subkunde-dialog/edit-subkunde-dialog.component';
export * from './lib/pages/subkunden-page/subkunden-page.component';

export * from './lib/types/subkunde';

export * from './lib/subkunden.routes';
export * from './lib/subkunden.providers';
export * from './lib/subkunden.shared';
